<!--
 * @Description  : 退款弹窗
 * @Author       : 王帅
 * @Date         : 2026-04-09 13:53:38
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-04-14 13:48:41
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\order-management\components\refund-dialog.vue
-->
<template>
	<el-dialog
		:visible.sync="visible"
		class="primary-dialog"
		width="1000px"
		:title="title"
		:close-on-click-modal="false"
		@close="handleClosed"
		center
	>
		<div v-if="visible">
			<div class="tips">
				<span class="green-icon"></span>
				<span class="mr10">无退款</span>
				<span>请输入退款申请信息</span>
			</div>
			<div class="mt20">
				<el-form ref="infoForm" :model="infoForm" label-width="130px" :rules="infoRules">
					<el-form-item label="退款金额" prop="amount">
						<el-input v-model="infoForm.amount" class="blue-color" clearable placeholder="请输入" v-decimal>
							<template #append>元</template>
						</el-input>
					</el-form-item>
					<el-form-item label="退款类型" required>
						<el-input value="手动退款" class="blue-color" placeholder="请输入" disabled></el-input>
					</el-form-item>
					<el-form-item label="退款原因" prop="refundReason">
						<el-input v-model="infoForm.refundReason" placeholder="请输入" clearable maxlength="50" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="退款方式" prop="isLine">
						<el-select v-model="infoForm.isLine" clearable>
							<el-option :value="0" label="线下退款"></el-option>
							<!-- <el-option :value="1" label="线上退款"></el-option> -->
						</el-select>
					</el-form-item>
					<el-form-item label="退款备注" prop="remark">
						<el-input type="textarea" v-model="infoForm.remark" placeholder="请输入" clearable maxlength="200" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="附件" required>
						<public-upload
							ref="uploadFile"
							:aid="infoForm.orderId"
							width="700px"
							listType="text"
							tableName="ngs_refund_record"
							assortment="ngs_refund_record"
							:maxNum="5"
							:acceptType="['png', 'jpg', 'jpeg', 'pdf', 'doc', 'xlsx']"
							:fileSize="10"
						></public-upload>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<div slot="footer" class="dialog-footer text-center">
			<el-button class="btn" size="small" @click="visible = false">取 消</el-button>
			<el-button type="primary" size="small" class="btn btn-blue" :loading="btnLoading" @click="doSave">保 存</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { selectServiceFeeRights, saveServiceFee } from 'api/modules/templateConfiguration'
import * as Api from '@/api/modules/order-management.js'
export default {
	data() {
		return {
			visible: false,
			btnLoading: false,
			title: '退款申请',
			infoForm: {
				orderId: '', // 订单id
				orderAm: null,	// 原订单金额
				amount: null, // 退款金额
				refundReason: '', // 退款原因
				isLine: '', // 退款方式 0 线下 1-线上
				remark: '' // 退款备注
			},
			infoRules: {
				amount: [{ required: true, message: '请输入退款金额', trigger: 'blur' }],
				refundReason: [{ required: true, message: '请输入退款原因', trigger: 'blur' }],
				isLine: [{ required: true, message: '请选择退款方式', trigger: 'change' }]
			}
		}
	},
	methods: {
		// 打开弹窗
		openDialog(row) {
			this.$set(this.infoForm, 'orderId', row.id)
			this.$set(this.infoForm, 'orderAm', row.orderAm)
			this.$set(this.infoForm, 'amount', row.orderAm)
			this.visible = true
		},
		doSave() {
			this.btnLoading = true
			this.$refs.infoForm.validate((valid) => {
				if (valid) {
					// 校验退款金额是否超出 订单金额
					if (parseFloat(this.infoForm.amount) > parseFloat(this.infoForm.orderAm)) {
						this.$message.warning('超过可退款金额上限，超出部分无法退款！')
						this.btnLoading = false
						return
					}

					// 再校验附件
					let fileLength =  this.$refs.uploadFile.fileLength === 0
					if (fileLength) {
						this.$message.warning('请上传附件！')
						this.btnLoading = false
						return
					}

					let params = {
						...this.infoForm
					}

					Api.manualRefund(params)
						.then((res) => {
							this.btnLoading = false
							this.$message.success('退款成功')
							this.visible = false
							this.$emit('doRefresh')
						})
						.catch((err) => {
							this.btnLoading = false
						})
				} else {
					this.$message.warning('有必填项未填，请填写')
					this.btnLoading = false
					return false
				}
			})
		},

		// 关闭弹窗
		handleClosed() {
			Object.assign(this.$data, this.$options.data.call(this))
			this.visible = false
			this.$emit('change')
		}
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo
		})
	}
}
</script>

<style scoped lang="less">
.tips {
	background-color: #eff6fe;
	display: flex;
	align-items: center;
	padding: 10px;
	line-height: 24px;

	.green-icon {
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background-color: #00ff00;
		margin-right: 10px;
	}
}
</style>
